import { Box } from "@mui/material"
import { Stack } from "@mui/system"
import React from "react"
import { useEffect } from "react"
import { getAssignments } from "../../api"
import { AssignmentCard, AssignmentExamCard } from "../cards/AssignmentExamCard"
import FilterSort from "../ui/FilterSort"

export const Fees = () => {
  const fetchData = () => {
    getAssignments()
      .then((res) => console.log(res.data))
      .catch((err) => console.log(err))
  }

  useEffect(() => {
    fetchData()
  }, [])
  return (
    <Box sx={{ width: "100%" }}>
      <Stack direction={"row-reverse"} justifyContent="flex-start">
        <FilterSort />
      </Stack>
      <Stack>
        <AssignmentCard />
        <AssignmentExamCard />
        <AssignmentExamCard />
      </Stack>
    </Box>
  )
}
